import { render, staticRenderFns } from "./UsersRoles.vue?vue&type=template&id=05f4d5f2"
import script from "./UsersRoles.vue?vue&type=script&lang=js"
export * from "./UsersRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports